import CoreStore from './core/store'
import modules from './store/index'

const store = new CoreStore({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    count: 1
  }
})

store.module('test', {
  namespaced: true,
  state: {
    info: 1
  }
})

for (let key in modules) {
  store.module(key, modules[key])
}

export default store.store()
